// Centralized definition of Starter (always included) and Optional (à activer) modules.
// Used on the signup module picker, Layout sidebar lock, and the "Activate module" modal.
// IMPORTANT: per current strategy, NO pricing is displayed anywhere — we only collect choices.

export const STARTER_MODULES = [
  { key: 'dashboard', label: 'Tableau de bord' },
  { key: 'crm', label: 'CRM' },
  { key: 'appointments', label: 'Agenda' },
  { key: 'quotes', label: 'Devis' },
  { key: 'invoices', label: 'Factures' },
  { key: 'auto_reminders', label: 'Relances automatiques' },
  { key: 'monthly_billing', label: 'Facturation mensuelle' },
  { key: 'price_library', label: 'Bibliothèque' },
  { key: 'accounting', label: 'Comptabilité' },
  { key: 'peppol', label: 'Peppol (e-facturation BE)' },
];

export const OPTIONAL_MODULES = [
  {
    key: 'stock',
    label: 'Stocks',
    description: 'Gestion produits + mouvements (entrées/sorties) avec alertes seuil bas.',
  },
  {
    key: 'tasks',
    label: 'Tâches & planning équipe',
    description: 'Assignation, timer chronométré, photos avant/après, check-lists et notes terrain.',
  },
  {
    key: 'hr',
    label: 'Module RH',
    description: 'Gestion employés, contrats, congés payés (BE/FR).',
  },
  {
    key: 'meetings',
    label: 'Réunions IA',
    description: 'Style Leexi — dictez ou collez vos notes, l’IA extrait résumé, décisions, actions.',
  },
  {
    key: 'analytics',
    label: 'Activité & Analytics',
    description: 'Journal complet des emails envoyés, statistiques d’usage, conversion devis → facture.',
  },
  {
    key: 'team',
    label: 'Multi-utilisateurs',
    description: 'Invitez votre équipe par email. Permissions module par module.',
  },
  {
    key: 'ai_voice',
    label: 'Dictée vocale IA',
    description: 'Dictez devis, tâches et réunions — l’IA structure tout (articles, dates, participants).',
  },
];

export const OPTIONAL_MODULE_KEYS = OPTIONAL_MODULES.map((m) => m.key);

export const findOptionalModule = (key) => OPTIONAL_MODULES.find((m) => m.key === key);
